import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Grid,
  Divider,
  Autocomplete,
  InputLabel,
  IconButton,
  FormControlLabel, 
  Switch,
} from "@mui/material";
import { Snackbar, Alert } from "@mui/material";
import { countries } from "../../constants/countrylist";
import {
  createNewPortfolioUser,
  PortfolioAssignDelegate,
} from "../../util/API/portfolio";
import { commonRunQuery } from "../../util/API/loans";
import CustomAlert from "../../components/UI/CustomAlert/CustomAlert";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CampaignIcon from "@mui/icons-material/Campaign";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
const AdminConsole = ({ onExit, userRole }) => {
  const [onboardData, setOnboardData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    areaCode: "",
    countryCode: "",
    gender: "",
    role: "", // Default to investor
    assignedInvestorId: "", // To store the selected investor for a delegate
    hasEntities: false,
    entities: [""],
  });

  const [investors, setInvestors] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [alert, setAlert] = useState({
    showAlert: false,
    message: "",
    severity: "",
    header: "",
    onConfirm: null,
    alertType: "",
  });
  const [adminTab, setAdminTab] = useState(0); // 0 = Onboard User, 1 = Announcements

const [funds, setFunds] = useState([]);

const [announcements, setAnnouncements] = useState([
  { id: 1, title: "Q3 Fund Statements Available", body: "Your Q3 statements have been uploaded to the Document Vault.", audienceType: "all", targetFundName: "" },
  { id: 2, title: "Demo Fund 2 — Capital Call Notice", body: "A capital call has been issued for Demo Fund 2.", audienceType: "fund", targetFundName: "Demo Fund 2" },
  {
    id: 3,
    title: "Platform Maintenance",
    body: "Scheduled maintenance this weekend, some features may be briefly unavailable.",
    audienceType: "All Investors",
    targetFundName: "",
  },
]);

const [announcementForm, setAnnouncementForm] = useState({
  title: "",
  body: "",
  audienceType: "all",
  targetFundId: "",
});
  let agentID = localStorage.getItem("authUser");

  // Fetch investors on component mount
  useEffect(() => {
    fetchInvestors();
    fetchFunds();
  }, []);

  useEffect(() => {
    if (userRole !== "admin") {
      console.log("Not Admin-----------");
      const currentUserId = JSON.parse(sessionStorage.getItem("user"))?.userid || "";
      setOnboardData((prev) => ({ 
        ...prev, 
        role: "delegate", 
        assignedInvestorId: currentUserId 
      }));
    } else {
      console.log("Admin-----------");
      setOnboardData((prev) => ({ ...prev, role: "investor" }));
    }
  }, [userRole]);

  const fetchInvestors = async () => {
    try {
      const response = await commonRunQuery(364, "");
      const records = response?.data?.body?.record;
      if (records) {
        // Ensure we handle both single object and array responses
        const formattedInvestors = Array.isArray(records) ? records : [records];
        const mapped = formattedInvestors.map((item) => {
          const u = item.u;
          const ue = item.ue;
          const record = item.record;
          const first = u.firstName?.trim();
          const last = u.lastName?.trim();

          return {
            id: u.investor_id,
            // name: `${u.firstName} ${u.lastName}`,
            name: `${first || ''} ${last || ''}`.trim() || u.otherNames,
            email: ue.email,
            totalInvested: `$${Number(record.total_invested_amount).toLocaleString("en-US", { minimumFractionDigits: 2 })}`,
            activeFunds: record.total_unique_funds,
            status: "Active",
          };
        });
        console.log("mapped=======",mapped);
        setInvestors(mapped);
      }
    } catch (error) {
      console.error("Failed to fetch investors:", error);
    }
  };
  const fetchFunds = async () => {
  try {
    const response = await commonRunQuery(359, "");
    const records = response?.data?.body?.record;
    if (records) {
      const recordsArray = Array.isArray(records) ? records : [records];
      const mapped = recordsArray.map((item) => ({
        id: item.funds.id,
        name: item.funds.name,
      }));
      setFunds(mapped);
    }
  } catch (error) {
    console.error("Failed to fetch funds:", error);
  }
};
  const handleInputChange = (e) => {
    console.log("e========",e);
    const { name, value } = e.target;
    console.log("name========",name);
    console.log("value========",value);
    setOnboardData((prev) => ({ ...prev, [name]: value }));
  };

  const clearFields = () => {
    setOnboardData({
      firstName: "",
      lastName: "",
      email: "",
      contactNumber: "",
      areaCode: "",
      countryCode: "",
      gender: "",
      role: userRole === "admin" ? "investor" : "delegate",
      assignedInvestorId: "",
      entities: [""],
    });
  };

  const validateForm = () => {
    const { firstName, lastName, email, contactNumber, countryCode, gender, role, assignedInvestorId } = onboardData;
    if (!firstName || !lastName || !email || !contactNumber || !countryCode || !gender || !role) return false;
    if (role === "delegate" && !assignedInvestorId) return false;
    return true;
  };

  const handleExistingUserDelegate = async (existingUserId) => {
    const targetInvestorId = userRole === "admin" ? onboardData.assignedInvestorId : (JSON.parse(sessionStorage.getItem("user"))?.userid || "");
    
    try {
      const assignResponse = await PortfolioAssignDelegate("", targetInvestorId, existingUserId);
      if (assignResponse) {
        setSnackbar({
          open: true,
          message: `User assigned successfully as a Delegate.`,
          severity: "success",
        });
        clearFields();
      }
    } catch (error) {
      console.error("Assignment Error:", error);
    } finally {
      setAlert((prev) => ({ ...prev, showAlert: false }));
    }
  };

  const handleOnboardSubmit = async () => {
    if (!validateForm()) {
      setSnackbar({ open: true, message: "Please fill in all required fields.", severity: "warning" });
      return;
    }

    const { role, entities, hasEntities, assignedInvestorId, firstName, lastName, email, countryCode, contactNumber, gender } = onboardData;
    const roleToBeSend = role;

    const filteredEntities = entities.filter(e => e.trim() !== "");

    console.log("Entities to save================", filteredEntities);

    try {
      const response = await createNewPortfolioUser(
        email, firstName, lastName, countryCode, contactNumber, gender, agentID, 2, roleToBeSend, filteredEntities, hasEntities
      );

      // Handle "Email already registered" case
      if (response?.payload?.callStatus === "0") {
        const existingUserId = response?.payload?.currentUserID;
        
        // Only show prompt if current role selection is Delegate
        if (role === "delegate" && existingUserId) {
          setAlert({
            showAlert: true,
            message: `A user with the email id ${email} already exists. Do you want to continue adding this user as a delegate?`,
            severity: "confirm",
            header: "Please Confirm",
            alertType: "confirm",
            onConfirm: () => handleExistingUserDelegate(existingUserId),
          });
        } else {
          setSnackbar({
            open: true,
            message: response.payload.msg || "This email cannot be registered.",
            severity: "error",
          });
        }
        return;
      }
      console.log("handleOnboardSubmit_role==============",role);
      if (response?.payload?.callStatus === "1") {
        const newUserId = response?.payload?.userid;
        console.log("handleOnboardSubmit_newUserId==============",newUserId);
        if (role === "delegate") {
          const targetInvestorId = userRole === "admin" ? assignedInvestorId : (JSON.parse(sessionStorage.getItem("user"))?.userid || "");
          console.log("handleOnboardSubmit_targetInvestorId==============",targetInvestorId);
          if (targetInvestorId && newUserId) {
            await PortfolioAssignDelegate("", targetInvestorId, newUserId);
          }
        }

        setSnackbar({
          open: true,
          message: `${firstName} ${lastName} onboarded successfully.`,
          severity: "success",
        });
        clearFields();
      }
    } catch (error) {
      setSnackbar({ open: true, message: "Something went wrong.", severity: "error" });
    }
  };

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };
  const handleAnnouncementSubmit = () => {
  const { title, body, audienceType, targetFundId } = announcementForm;
  if (!title.trim() || !body.trim()) {
    setSnackbar({ open: true, message: "Title and body are required.", severity: "warning" });
    return;
  }
  const targetFundName = funds.find((f) => f.id === targetFundId)?.name || "";
  setAnnouncements((prev) => [{ id: Date.now(), title, body, audienceType, targetFundName }, ...prev]);
  setAnnouncementForm({ title: "", body: "", audienceType: "all", targetFundId: "" });
  setSnackbar({ open: true, message: "Announcement published.", severity: "success" });
};

const handleDeleteAnnouncement = (id) => {
  setAnnouncements((prev) => prev.filter((a) => a.id !== id));
};
  const handleEntityChange = (index, value) => {
    const newEntities = [...onboardData.entities];
    newEntities[index] = value;
    setOnboardData({ ...onboardData, entities: newEntities });
  };
  
  const addEntityField = () => {
    setOnboardData({ ...onboardData, entities: [...onboardData.entities, ""] });
  };
  
  const removeEntityField = (index) => {
    const newEntities = onboardData.entities.filter((_, i) => i !== index);
    setOnboardData({ ...onboardData, entities: newEntities.length ? newEntities : [""] });
  };

  console.log("onboardData------------", onboardData);
  console.log("userRole------------", userRole);

  return (
    <Box className="admin-container">
      <Box className="header-card">
        <Box>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="h5" fontWeight="bold">
              THE HOLT XCHANGE
            </Typography>
            <Typography
              variant="h6"
              sx={{ ml: 2, borderLeft: "1px solid #ccc", pl: 2 }}
            >
              Admin Console
            </Typography>
          </Box>
          <Typography variant="body2" color="textSecondary">
            Manage users, uploads, investor profiles, and permissions
          </Typography>
        </Box>
        <Button
          variant="outlined"
          onClick={onExit}
          sx={{ textTransform: "none", color: "#000", borderColor: "#000" }}
        >
          Exit Admin
        </Button>
      </Box>
      <Tabs
        value={adminTab}
        onChange={(e, v) => setAdminTab(v)}
        sx={{ mb: 3, borderBottom: 1, borderColor: "divider" }}
      >
        <Tab
          icon={<PersonAddIcon fontSize="small" />}
          iconPosition="start"
          label="Onboard User"
          sx={{ textTransform: "none" }}
        />
        <Tab
          icon={<CampaignIcon fontSize="small" />}
          iconPosition="start"
          label="Announcements"
          sx={{ textTransform: "none" }}
        />
      </Tabs>
      {adminTab === 0 && (      <Box className="dashboard-card" sx={{ mb: 3 }}>
        <Typography variant="h6" fontWeight="bold">
          Onboard New User
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
          Enter the details below to create a new user profile.
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="First Name"
              name="firstName"
              size="small"
              required
              value={onboardData.firstName}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Last Name"
              name="lastName"
              size="small"
              required
              value={onboardData.lastName}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Email Address"
              name="email"
              type="email"
              size="small"
              required
              value={onboardData.email}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Contact Number"
              name="contactNumber"
              size="small"
              required
              value={onboardData.contactNumber}
              onChange={handleInputChange}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <Autocomplete
              options={countries.filter((c) => c.id !== "novalue")}
              getOptionLabel={(option) =>
                `${option.country} (${option.areaCode})`
              }
              value={
                countries.find((c) => c.flag === onboardData.countryCode) ||
                null
              }
              onChange={(event, newValue) => {
                setOnboardData((prev) => ({
                  ...prev,
                  areaCode: newValue ? newValue.areaCode : "",
                  countryCode: newValue ? newValue.flag : "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Country Code"
                  size="small"
                  required
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <FormControl fullWidth size="small" required>
              <InputLabel>Gender</InputLabel>
              <Select
                name="gender"
                value={onboardData.gender}
                onChange={handleInputChange}
                label="Gender"
              >
                <MenuItem value="1">Male</MenuItem>
                <MenuItem value="2">Female</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {userRole === "admin" && (
            <>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth size="small" required>
                  <InputLabel>Role</InputLabel>
                  <Select
                    name="role"
                    value={onboardData.role}
                    onChange={handleInputChange}
                    label="Role"
                  >
                    <MenuItem value="investor">Investor</MenuItem>
                    <MenuItem value="delegate">Delegate</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {onboardData.role == "delegate" && userRole == "admin" && (
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth size="small" required>
                    <InputLabel>Assign to Investor</InputLabel>
                    <Select
                      name="assignedInvestorId"
                      value={onboardData.assignedInvestorId}
                      onChange={handleInputChange}
                      label="Assign to Investor"
                    >
                      {investors.map((inv) => (
                        <MenuItem key={inv.id} value={inv.id}>
                          {inv.name} ({inv.email})
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
            </>
          )}

          {/* Logic for Admin + Investor Role */}
          {onboardData.role === "investor" && (
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={onboardData.hasEntities}
                    onChange={(e) =>
                      setOnboardData({
                        ...onboardData,
                        hasEntities: e.target.checked,
                      })
                    }
                    color="primary"
                  />
                }
                label="Does this investor have associated entities?"
              />

              {onboardData.hasEntities && (
                <Box
                  sx={{
                    mt: 2,
                    p: 2,
                    border: "1px dashed #ccc",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Add Entities
                  </Typography>
                  {onboardData.entities.map((entity, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 1,
                        gap: 1,
                      }}
                    >
                      <TextField
                        fullWidth
                        size="small"
                        label={`Entity Name ${index + 1}`}
                        value={entity}
                        onChange={(e) =>
                          handleEntityChange(index, e.target.value)
                        }
                      />
                      <IconButton onClick={addEntityField} color="primary">
                        <AddCircleOutlineIcon />
                      </IconButton>
                      {onboardData.entities.length > 1 && (
                        <IconButton
                          onClick={() => removeEntityField(index)}
                          color="error"
                        >
                          <RemoveCircleOutlineIcon />
                        </IconButton>
                      )}
                    </Box>
                  ))}
                </Box>
              )}
            </Grid>
          )}

          <Grid item xs={12}>
            <Divider sx={{ my: 1, borderStyle: "dashed" }} />
            <Button
              variant="contained"
              onClick={handleOnboardSubmit}
              sx={{ bgcolor: "#001529", textTransform: "none", mt: 1, px: 4 }}
            >
              Complete Onboarding
            </Button>
          </Grid>
        </Grid>
      </Box>)}

          {adminTab === 1 && (
  <Box className="dashboard-card" sx={{ mb: 3 }}>
    <Typography variant="h6" fontWeight="bold">New Announcement</Typography>
    <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
      Published announcements appear on the investor dashboard.
    </Typography>

    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField fullWidth size="small" label="Title" value={announcementForm.title}
          onChange={(e) => setAnnouncementForm((p) => ({ ...p, title: e.target.value }))} />
      </Grid>
      <Grid item xs={12}>
        <TextField fullWidth size="small" label="Body" multiline minRows={3} value={announcementForm.body}
          onChange={(e) => setAnnouncementForm((p) => ({ ...p, body: e.target.value }))} />
      </Grid>
      <Grid item xs={12} md={4}>
        <FormControl fullWidth size="small">
          <InputLabel>Audience</InputLabel>
          <Select label="Audience" value={announcementForm.audienceType}
            onChange={(e) => setAnnouncementForm((p) => ({ ...p, audienceType: e.target.value, targetFundId: "" }))}>
            <MenuItem value="all">All Investors</MenuItem>
            <MenuItem value="fund">Specific Fund</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      {announcementForm.audienceType === "fund" && (
        <Grid item xs={12} md={5}>
          <FormControl fullWidth size="small">
            <InputLabel>Target Fund</InputLabel>
            <Select label="Target Fund" value={announcementForm.targetFundId}
              onChange={(e) => setAnnouncementForm((p) => ({ ...p, targetFundId: e.target.value }))}>
              {funds.map((f) => <MenuItem key={f.id} value={f.id}>{f.name}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>
      )}
      <Grid item xs={12}>
        <Divider sx={{ my: 1, borderStyle: "dashed" }} />
        <Button variant="contained" onClick={handleAnnouncementSubmit} sx={{ bgcolor: "#001529", textTransform: "none" }}>
          Publish Announcement
        </Button>
      </Grid>
    </Grid>

    <Divider sx={{ my: 3 }} />

    <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
      Published Announcements ({announcements.length})
    </Typography>
    {announcements.map((a) => (
      <Box key={a.id} sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", p: 1.5, mb: 1, border: "1px solid #eee", borderRadius: 1 }}>
        <Box sx={{ flex: 1, mr: 2 }}>
          <Typography variant="body1" fontWeight="bold">{a.title}</Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 0.5 }}>{a.body}</Typography>
          <Typography variant="caption" color="primary">{a.audienceType === "all" ? "All Investors" : a.targetFundName}</Typography>
        </Box>
        <IconButton size="small" color="error" onClick={() => handleDeleteAnnouncement(a.id)}>
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </Box>
    ))}
  </Box>
)}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <CustomAlert
        severity={alert.severity}
        show={alert.showAlert}
        header={alert.header}
        message={alert.message}
        onClick={(prevDetails) => {
          setAlert({ ...prevDetails, showAlert: false });
        }}
        alertType={alert.alertType}
        confirmButton={alert.onConfirm}
        autoclose={alert.severity === "error" ? false : true}
      />
    </Box>
  );
};

export default AdminConsole;